package app.components

import app.model.ProjectWithDependencies
import app.svg.chevronDown
import dev.fritz2.core.*

fun RenderContext.companyStageDropdown(
    selectedStage: String,
    selectedCompanies: List<String>,
    companyProjects: List<ProjectWithDependencies.Company>,
    isDropdownOpen: Store<Boolean>,
    onCompanySelectionChange: (List<String>) -> Unit
) {
    div("relative") {
        button(
            "w-52 rounded flex justify-between h-10 text-center inline-flex items-center dark:text-white " +
                    (if (selectedStage.isEmpty())
                        "bg-gray-400 cursor-not-allowed opacity-60"
                    else
                        "bg-blue-500")
        ) {
            disabled(selectedStage.isEmpty())
            div("ml-3") {
                if (selectedCompanies.isNotEmpty()) {
                    +"${selectedCompanies.joinToString(", ")}"
                } else {
                    +"Select Companies"
                }
            }
            chevronDown("size-3.5 mr-0.5")
            clicks handledBy { isDropdownOpen.update(!isDropdownOpen.current) }
        }

        isDropdownOpen.data.render { isOpen ->
            if (isOpen) {
                div("absolute z-10 w-52 bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700 rounded-lg shadow mt-1") {
                    ul("p-3 space-y-3 text-sm text-gray-700 dark:text-gray-300") {
                        companyProjects.filter { company ->
                            company.stages.any { it.name == selectedStage }
                        }.forEach { company ->
                            li("flex items-center") {
                                input(
                                    "w-4 h-4 text-blue-600 bg-gray-100 dark:bg-gray-700 " +
                                            "border-gray-300 dark:border-gray-600 rounded focus:ring-blue-500"
                                ) {
                                    type("checkbox")
                                    id("checkbox-${company.id}")
                                    checked(selectedCompanies.contains(company.name))
                                    changes.states() handledBy { checked ->
                                        if (checked) {
                                            onCompanySelectionChange(selectedCompanies + listOf(company.name))
                                        } else {
                                            onCompanySelectionChange(selectedCompanies.filter { it != company.name })
                                        }
                                    }
                                }
                                label("ms-2 text-sm font-medium text-gray-900 dark:text-gray-300") {
                                    `for`("checkbox-${company.id}")
                                    +company.name
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}